import React from 'react';
import styles from '../lauragerolin/lauragerolin.module.scss';
import LinkPersonalizado7 from '../../components/LinkPersonalizado7/linkPersonalizado7.tsx';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import MapsIcon from '../../icons/mapsIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';

const Lauragerolin: React.FC = () => {

    return (
        <div className={styles.lauragerolin}>
            <div className={styles["body-thunder"]}>
                <div className={`${styles["container-thunder"]}`} >
                    <h1 className="pt-2 mb-0">Laura Gerolin</h1>
                    <p className="mb-0">NUTRICIONISTA</p>
                    <p>SAÚDE DA MULHER & EMAGRECIMENTO</p>
                    <div className={styles.links}>
                        <LinkPersonalizado7
                            href="https://www.instagram.com/lauragerolin?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                            title="INSTAGRAM"
                            icon={<InstagramIcon height="32" color="#ffffff" />}
                            colorText="#cbb353"
                            spaceBetween={true}
                        />
                        <LinkPersonalizado7
                            href="https://wa.me/5517981360002?text=Olá, Vim pelo link na bio e gostaria de mais informações..."
                            title="WHATSAPP"
                            icon={<WhatsappIcon height="40" color="#ffffff" />}
                            colorText="#cbb353"
                            spaceBetween={true}
                        />
                        <LinkPersonalizado7
                            href="https://maps.app.goo.gl/dDckPPbMYrPxd7tA7"
                            title="LOCALIZAÇÃO"
                            icon={<MapsIcon height="40" color="#ffffff" />}
                            colorText="#cbb353"
                            spaceBetween={true}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Lauragerolin;
